import { useNavigate } from 'react-router-dom';

export default function useMobileRouter() {
  const navigate = useNavigate();
  const push = (url: string) => {
    navigate(url);
  };

  return { push };
}
